import Fill from 'ol/style/Fill'
import Stroke from 'ol/style/Stroke'
import Style from 'ol/style/Style'

export const emptyStyle = new Style()
// new Style({
//   fill: new Fill({
//     color: 'rgba(0, 0, 0, 00)',
//   }),
//   stroke: new Stroke({
//     color: 'rgba(0, 0, 0, 00)',
//     width: 0,
//   }),
// })
